export const FilterBy = (samples, cellAttribute, value) => {
	let filteredSamples = []
	
	for(let i = 0; i < samples.length; i++){
		const sample = samples[i]
		
		if(sample[cellAttribute] === value){
			filteredSamples.push(sample)
		}
	}
	
	return filteredSamples
}